export const initialState = {
  imgPath: undefined,
  backgroundInformation: "",
  firstName: "",
  lastName: "",
  email: "",
  birthday: "",
  primaryLanguage: "Eng",
  currentSchool: "",
  currentGrade: "",
  publicExams: "IGCSE",
  personalityType: "",
  specialRequest: "",
  allergiesCondition: "",
  favouriteSubjects: "",
  leastFavouriteSubjects: "",
  favouriteColour: "",
  favouriteFood: "",
  favouriteAnimal: "",
  favouriteHobby: "",
  favouriteVideoGames: "",
  favouriteMovies: "",
  favouriteSport: "",
  nftPath: "",
  parentId: undefined,
  age: 0,
  carNumber1: undefined,
  carNumber2: undefined,
};

export const languages = [
  { value: "Eng", label: "English" },
  { value: "Man", label: "Mandarin" },
  { value: "Can", label: "Cantonese" },
  { value: "Jap", label: "Japanese" },
  { value: "Kor", label: "Korean" },
  { value: "Others", label: "Others" },
];
export const examinations = [
  { value: "IGCSE", label: "IGCSE" },
  { value: "IB", label: "IB" },
  { value: "AL", label: "A-Levels" },
  { value: "DSE", label: "HKDSE" },
  { value: "AP", label: "American AP" },
  { value: "Others", label: "Others" },
];

export const initialAddCoursePurchaseModalReducerState = {
  show: false,
};

export const studentTableColumns = [
  {
    id: "studentId",
    Header: "Student ID",
    accessor: "id",
    sortable: true,
    filterable: true,
  },
  {
    id: "studentCentre",
    Header: "Centre",
    accessor: (row) => row?.centre?.shortName || "None",
    sortable: true,
    filterable: true,
  },
  {
    id: "firstName",
    Header: "First Name",
    accessor: "firstName",
    sortable: true,
    filterable: true,
  },
  {
    id: "lastName",
    Header: "Last Name",
    accessor: "lastName",
    sortable: true,
    filterable: true,
  },
  {
    id: "parentName",
    Header: "Parent Name",
    accessor: (row) => row.parent.firstName + " " + row.parent.lastName,
    sortable: true,
    filterable: true,
  },
  {
    id: "headTeacher",
    Header: "Head Teacher",
    accessor: (row) => (row.headTeacher ? row.headTeacher.fullName : "None"),
    sortable: true,
    filterable: true,
  },
  {
    id: "isActive",
    Header: "Active",
    accessor: (row) => (row.isActive ? "YES" : "NO"),
    sortable: true,
    filterable: true,
    filter: (rows, columnIds, filterValue) => {
      if (filterValue === "all") return rows;
      return rows.filter((row) => row.values.isActive === filterValue);
    },
    Filter: ({ setFilter, column }) => (
      <select
        className="form-control"
        onChange={(event) => setFilter(column.id, event.target.value)}
        onClick={(e) => e.stopPropagation()}
      >
        {[
          { value: "all", label: "All" },
          { value: "YES", label: "Active" },
          { value: "NO", label: "Deactivated" },
        ].map(({ value, label }) => (
          <option value={value} key={label}>
            {label}
          </option>
        ))}
      </select>
    ),
  },
  {
    id: "email",
    Header: "Email",
    accessor: "email",
    sortable: true,
    filterable: true,
  },
  {
    id: "actions",
    Header: "actions",
    accessor: "actions",
    sortable: false,
    filterable: false,
  },
];
